import React from 'react';
import ArticleCard from './ArticleCard';

const ArticleGrid = ({ posts, loading, error }) => {
  if (loading) {
    return (
      <section style={{ padding: '64px 6%', background: '#050A12' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '28px', maxWidth: '1400px' }}>
          {[...Array(6)]?.map((_, i) => (
            <div
              key={i}
              style={{
                background: '#0D1520',
                height: '380px',
                border: '1px solid rgba(255,255,255,0.07)',
                animation: 'pulse 1.5s ease-in-out infinite',
                opacity: 0.6
              }}
            />
          ))}
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section style={{ padding: '64px 6%', background: '#050A12' }}>
        <div style={{ textAlign: 'center', padding: '60px 0' }}>
          <p style={{ fontFamily: 'Syne, sans-serif', fontSize: '1.1rem', color: '#E76F51', fontWeight: 700 }}>Kunne ikke laste artikler</p>
          <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.9rem', color: 'rgba(238,240,242,0.5)', marginTop: '8px' }}>{error}</p>
        </div>
      </section>
    );
  }

  if (!posts?.length) {
    return (
      <section style={{ padding: '64px 6%', background: '#050A12' }}>
        <div style={{ textAlign: 'center', padding: '80px 0' }}>
          <div style={{ fontFamily: 'Impact, sans-serif', fontSize: '4rem', color: 'rgba(255,255,255,0.06)', marginBottom: '16px' }}>TOMT</div>
          <p style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: '1rem', color: 'rgba(238,240,242,0.4)' }}>Ingen artikler funnet for dette filteret.</p>
        </div>
      </section>
    );
  }

  return (
    <section style={{ padding: '64px 6%', background: '#050A12' }}>
      {/* Section label */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '40px' }}>
        <div style={{ width: '6px', height: '40px', background: 'rgba(59,111,212,0.4)' }} />
        <div>
          <p style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.7rem', fontWeight: 700, color: 'rgba(59,111,212,0.7)', letterSpacing: '0.25em', textTransform: 'uppercase', margin: 0 }}>Alle artikler</p>
          <h2 style={{ fontFamily: 'Impact, sans-serif', fontSize: 'clamp(1.5rem, 3vw, 2.5rem)', fontWeight: 900, color: '#EEF0F2', margin: 0, textTransform: 'uppercase', letterSpacing: '-0.02em' }}>SISTE SAKER</h2>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '28px', maxWidth: '1400px' }}>
        {posts?.map((post, index) => (
          <ArticleCard key={post?.id} post={post} index={index} />
        ))}
      </div>
    </section>
  );
};

export default ArticleGrid;
